import { render, staticRenderFns } from "./Afterworks.vue?vue&type=template&id=725f5ecd&"
import script from "./Afterworks.vue?vue&type=script&lang=js&"
export * from "./Afterworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports